import { useMsal } from '@azure/msal-react'
import { useMutation } from '@tanstack/react-query'
import { AppButton, AppTypography } from 'components/base'
import { ApiQueryKeys } from 'globals/constants'
import { msalloginRequestScopes } from 'globals/constants/msal.config'
import { useLogin } from 'hooks'
import { useSnackbar } from 'notistack'
import { FC } from 'react'
import { AuthApi, SessionModel } from 'sdk'

interface Props {}

export const MicrosoftLoginButton: FC<Props> = () => {
  const authApi = new AuthApi()
  const { handleLoginSuccess } = useLogin()
  const { enqueueSnackbar } = useSnackbar()
  const { instance } = useMsal()

  const { mutate: login, isPending } = useMutation({
    mutationKey: [ApiQueryKeys.auth.microsoftLogin],
    mutationFn: (token: string) => authApi.microsoftLogin({ Token: token }),
    onSuccess: (data: SessionModel) => {
      handleLoginSuccess(data)
    },
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
  })
  const handleLogin = () => {
    instance
      .loginPopup(msalloginRequestScopes)
      .then((res) => {
        login(res.idToken)
      })
      .catch((err) => enqueueSnackbar(err, { variant: 'error' }))
  }

  return (
    <AppButton
      variant="outlined"
      color="secondary"
      prefixIcon="logos:microsoft-icon"
      size="large"
      sidePaddings={3}
      isLoading={isPending}
    >
      <AppTypography fontSize={16} fontWeight={600} color={'grey.900'} onClick={handleLogin}>
        Sign in using Microsoft
      </AppTypography>
    </AppButton>
  )
}
